module.exports = __webpack_public_path__ + "png/straight_flush.png?3c537c76c3febaa05c578d76352c1d61";